export const LookupsAPI = {
  workersByBusinessUnitId: (id: string | number | null) =>
    `<%userArea%>/businessunits/${id}/clientemployees`,
  terminatedWorkersByBusinessUnitId: (id: string | number | null) =>
    `<%userArea%>/keypay/GetInactiveClientEmployeesByName/${id}`,
  companies: `<%userArea%>/lookups/companies`,
  businessUnitAssignedUsers: '<%userArea%>/lookups/businessUnitAssignedUsers',
};
